import { graphql } from '../gql';

export const SOME_FINAL_FORMS = graphql(`
  query someFinalForms($policyId: ID, $businessId: ID) {
    someFinalForms(policy: $policyId, business: $businessId) {
      ...AmendedFormFields
    }
  }
`);
